import { Menu } from "@headlessui/react";

export const PublishVendorToCloudContextMenus = ({
    setAnchorShipmentEl,
    anchorShipmentEl,
    handleParticularOrgRegistry,
    row,
}) => {
    console.log(row, 'row');

    // Define conditions for enabling the Publish button
    const isPublishEnabled = row.IsPublished === false && row.AccountInfo.TypeId !== 220;

    return (
        <>
            <Menu as="div" className="relative text-left">
                <div>
                    <Menu.Button
                        onClick={(e) => setAnchorShipmentEl(e.currentTarget)}
                        className="pt-1 pl-1 text-gray-700 hover:text-gray-900 rounded cursor-pointer"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                            width="18"
                            height="18"
                        >
                            <circle cx="12" cy="5" r="2" />
                            <circle cx="12" cy="12" r="2" />
                            <circle cx="12" cy="19" r="2" />
                        </svg>
                    </Menu.Button>
                </div>

                {anchorShipmentEl && (
                    <Menu.Items
                        className="absolute z-10 bg-white border border-gray-300 rounded shadow-lg w-60 p-1 max-h-60 overflow-y-auto"
                        style={{ left: '-200px' }}
                    >
                        <div className="px-1 py-1">
                            <Menu.Item>
                                {({ active }) => (
                                    <button
                                        onClick={() => {
                                            if (isPublishEnabled) {
                                                handleParticularOrgRegistry(row);
                                            }
                                            setAnchorShipmentEl(null);
                                        }}
                                        className={`${
                                            active ? 'bg-gray-100' : ''
                                        } group flex rounded-md items-center w-full px-2 py-2 text-sm text-black ${
                                            isPublishEnabled ? 'cursor-pointer' : 'opacity-50 cursor-not-allowed'
                                        }`}
                                        title="Publish Particular org registry to cloud"
                                        disabled={!isPublishEnabled}
                                    >
                                        Publish to Cloud
                                    </button>
                                )}
                            </Menu.Item>
                        </div>
                    </Menu.Items>
                )}
            </Menu>
        </>
    );
};
